import { Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService, LanguageService, PageType, RoutingService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { BehaviorSubject, Observable, filter, take, tap } from 'rxjs';
import { EbProductService} from "../../features/product/services/facades/eb-product.service";
import { EBResponsiveHighlightData } from "./eb-responsive-highlight.interface";

@Component({
    selector: 'eb-responsive-highlight',
    templateUrl: './eb-responsive-highlight.component.html',
    styleUrl: './eb-responsive-highlight.component.scss',
    standalone: false
})
export class EBResponsiveHighlightComponent implements OnInit ,OnDestroy {
  routerLink$ = new BehaviorSubject<string | any[]>(null);

  public componentData$: Observable<EBResponsiveHighlightData> = this.componentData.data$;

  constructor(
    protected componentData: CmsComponentData<EBResponsiveHighlightData>,
    protected languageService: LanguageService,
    protected cmsService: CmsService,
    protected productService: EbProductService,
    protected routingService: RoutingService,
  ) {}

  ngOnDestroy(): void {
       this.routerLink$.unsubscribe();
    }

  ngOnInit(): void {
    this.languageService.getActive().subscribe((languageData) => {
        this.componentData.data$.pipe(take(1) , tap((data) => {
          this.setRouterLink(data);
        })).subscribe();
      }
    )
  }

  getTarget(data: EBResponsiveHighlightData): string | null {
    return (data.external === undefined && data.externalLink === undefined) ||
    data.external === 'true' ||
    data.external === true ||
    data.externalLink === 'true' ||
    data.externalLink === true
      ? '_blank'
      : ''
  }

  hasUrl(data: EBResponsiveHighlightData): boolean {
    return data.urlLink && typeof data.urlLink === 'string' && data.urlLink !== ''
  }

  protected setRouterLink(data: EBResponsiveHighlightData): void {
    if (data.urlLink) {
      this.routerLink$.next(data.urlLink);
    } else if (data.contentPage) {
      this.cmsService
        .getPage({
          id: data.contentPage,
          type: PageType.CONTENT_PAGE,
        })
        .pipe(take(1))
        .subscribe((page) => {
          this.routerLink$.next(page?.label);
        });
    } else if (data.product) {
      this.productService.get(data.product).pipe(
        filter(value => value !== undefined),
        take(1)
      )
        .subscribe(ebProduct => {
          this.routerLink$.next( this.routingService.getFullUrl({
          cxRoute: 'product',
          params: ebProduct
        }))
      })

    } else if (data.category) {
      this.routerLink$.next(`/c/${data.category}`)
    }
    else {
      this.routerLink$.next(data.buttonLink);
    }
  }

}
